<template>
  <div id="btnGroupDossierPaiement" class="pay-btn-group">
    <template v-if="$store.state.isWorkingCB === false">
      <button type="button" class="pay-btn" @click="paiement('cb')">
        Paiement par CB
      </button>
    </template>
    <template v-else-if="$store.state.isWorkingCB">
      <button type="button" class="pay-btn pay-btn--loading" disabled>
        <i class="fa fa-spinner fa-spin"></i> Paiement par CB
      </button>
    </template>
    <template v-else-if="
      $store.state.isWorkingCB === null &&
      !$store.state.isWorkingCPF &&
      !$store.state.isWorkingAutre
    ">
      <button type="button" class="pay-btn pay-btn--active" disabled>
        Paiement par CB
      </button>
    </template>
    <template v-else>
      <button type="button" class="pay-btn pay-btn--muted" disabled>
        Paiement par CB
      </button>
    </template>

    <template v-if="!messageAutre">
      <template v-if="$store.state.isWorkingCPF === false">
        <button type="button" class="pay-btn" @click="paiement('cpf')">
          Paiement par CPF ou Pole Emploi
        </button>
      </template>
      <template v-else-if="$store.state.isWorkingCPF">
        <button type="button" class="pay-btn pay-btn--loading" disabled>
          <i class="fa fa-spinner fa-spin"></i> Paiement par CPF ou Pole Emploi
        </button>
      </template>
      <template v-else-if="
        $store.state.isWorkingCPF === null &&
        !$store.state.isWorkingCB &&
        !$store.state.isWorkingAutre
      ">
        <button type="button" class="pay-btn pay-btn--active" disabled>
          Paiement par CPF ou Pole Emploi
        </button>
      </template>
      <template v-else>
        <button type="button" class="pay-btn pay-btn--muted" disabled>
          Paiement par CPF ou Pole Emploi
        </button>
      </template>

      <template v-if="$store.state.isWorkingAutre === false">
        <button type="button" class="pay-btn" @click="paiement('autre')">
          Autres modes de paiement
        </button>
      </template>
      <template v-else-if="$store.state.isWorkingAutre">
        <button type="button" class="pay-btn pay-btn--loading" disabled>
          <i class="fa fa-spinner fa-spin"></i> Autres modes de paiement
        </button>
      </template>
      <template v-else-if="
        $store.state.isWorkingAutre === null &&
        !$store.state.isWorkingCB &&
        !$store.state.isWorkingCPF
      ">
        <button type="button" class="pay-btn pay-btn--active" disabled>
          Autres modes de paiement
        </button>
      </template>
      <template v-else>
        <button type="button" class="pay-btn pay-btn--muted" disabled>
          Autres modes de paiement
        </button>
      </template>
    </template>
  </div>
  <template v-if="!messageAutre">
    <p>{{ this.$store.state.messagePaiement }}</p>
  </template>
  <template v-else-if="this.$store.state.messagePaiement.length != 0">
    <p>
      {{
  "Si vous souhaitez effectuer le payement par CPF ou par un autre moyen, m" +
    this.$store.state.messagePaiement.slice(1)
      }}
    </p>
  </template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// this.$store.dispatch("startSaveBouton", mode);
//
// let router = this.$router;
// this.$store.dispatch("endSaveBouton", { mode, fonctionnalite, router });


// Pour chaque bouton

// Si isWorking === false
//// outline cliquable

// Si isWorking === true
//// outline spinner

// Si isWorking === null && les autres isWorking === false
//// disabled

// Sinon
//// outline disabled


export default {
  name: "BoutonFormulaire",
  props: {
    messageAutre: { type: Boolean },
  },
  data() {
    return {};
  },
  mounted() {
    // this.checkEtatBoutons();
    // Remet les boutons à l'état neutre (cliquable) à chaque affichage du composant :
    // sans ça, revenir sur cette page avec le bouton "retour" du navigateur après un clic
    // sur "Paiement par CB" laisse les 3 boutons bloqués (isWorkingCB reste à null au lieu de false).
    this.$store.commit("setIsWorkingCB", false);
    this.$store.commit("setIsWorkingCPF", false);
    this.$store.commit("setIsWorkingAutre", false);
  },
  methods: {
    ...mapActions([]),
    checkEtatBoutons() {
      console.log(this.$store.state.isWorkingAutre, this.$store.state.isWorkingCB, this.$store.state.isWorkingCPF);
    },

    paiement(mode) {
      // Lance la fonction de la template précédente qui ammène au paiement
      this.$emit("paiement", mode);
    },
  },
  computed: {
    ...mapGetters([]),
  },
};
</script>

<style scoped>
#btnGroupDossierPaiement.pay-btn-group {
  display: flex;
  gap: 12px;
  width: 100%;
}

.pay-btn-group > button {
  flex: 1;
}

.pay-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 16px;
  border: 1.5px solid #3b82f6;
  border-radius: 12px;
  background: #ffffff;
  color: #3b82f6;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  transition: background .15s, box-shadow .15s, border-color .15s;
}

.pay-btn:hover {
  background: #eff6ff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, .12);
}

.pay-btn--loading {
  cursor: default;
  opacity: .85;
}

.pay-btn--loading:hover {
  background: #ffffff;
  box-shadow: none;
}

.pay-btn--active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
  cursor: default;
}

.pay-btn--active:hover {
  background: #3b82f6;
  box-shadow: none;
}

.pay-btn--muted {
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #94a3b8;
  cursor: default;
}

.pay-btn--muted:hover {
  background: #f8fafc;
  box-shadow: none;
}
</style>
